import { Variants, motion } from "framer-motion";
import Card from "../../components/servicesComponents/card";
import GetInTouch from "../../components/get-in-touch";
import { membershipsData } from "../../data/membershipsData";
import { headingVariants, viewportSettings } from "../../shared/utils/animations";
import styles from "./memberships.module.scss";

function getRandomFloat(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

const Memberships = () => {
  const BOOKING_URL = `https://www.vagaro.com/lawameraki/services`;

  const headingVariantsCustom: Variants = {
    headingOffScreen: {
      opacity: 0,
      scale: 0.9,
      y: -30,
    },
    headingOnScreen: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: getRandomFloat(0.6, 0.8),
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  };

  return (
    <>
      <motion.div
        initial="headingOffScreen"
        whileInView="headingOnScreen"
        viewport={viewportSettings}
        variants={headingVariantsCustom}
      >
        <div className={styles["container"]}>
          <motion.div
            initial="headingOffScreen"
            whileInView="headingOnScreen"
            viewport={viewportSettings}
            variants={headingVariants}
          >
            <h1>Our Memberships</h1>
          </motion.div>

          <p className={styles["description"]}>
            Browse our variety of premium salon memberships and enjoy exclusive benefits.
          </p>

          <div className={styles["memberships-card-container"]}>
            {membershipsData.map((membership: any, index: number) => (
              <div key={index} className={styles["membership-card"]}>
                <Card data={membership} />
              </div>
            ))}
          </div>

          <p className={styles["purchase-info"]}>To purchase, call us 619-535-7828</p>

          <motion.div
            initial="headingOffScreen"
            whileInView="headingOnScreen"
            viewport={viewportSettings}
            variants={headingVariants}
          >
            <button
              onClick={() => {
                window.open(BOOKING_URL, "_blank");
              }}
            >
              Book
            </button>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        initial="headingOffScreen"
        whileInView="headingOnScreen"
        viewport={viewportSettings}
        variants={headingVariants}
      >
        <GetInTouch />
      </motion.div>
    </>
  );
};

export default Memberships;
